import React from 'react';
import PropTypes from 'prop-types';
import SentimentSlider from 'zignal-widgets/lib/SentimentSlider';
import ToolTip from 'zignal-landscape/lib/ToolTip';

const DISABLED_TOOLTIP = (
  <span>Sentiment overrides are disabled<br />for Curated Datasets.</span>
);

const NewsroomSentimentSlider = ({ selectedValue, onChange, disabled }) => {
  const slider = (
    <SentimentSlider
      selectedValue={selectedValue}
      onChange={disabled ? undefined : onChange}
      disabled={disabled}
    />
  );

  if (disabled) {
    // ToolTip uses rc-trigger which attaches onMouseEnter/Leave via React.cloneElement.
    // SentimentSlider is a themeable HOC and does not forward those props to its DOM node,
    // so the tooltip never fires. Wrapping in a plain div gives cloneElement a real DOM
    // element to attach mouse events to.
    return (
      <ToolTip position="top" tooltipText={DISABLED_TOOLTIP}>
        <div>{slider}</div>
      </ToolTip>
    );
  }

  return slider;
};

NewsroomSentimentSlider.propTypes = {
  selectedValue: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default NewsroomSentimentSlider;
